// extracted by mini-css-extract-plugin
module.exports = {"stripedTable":"stripedtable_stripedTable__1YUM1"};